import React from 'react'
import { AlertTriangle } from 'lucide-react'
import { UnsubmittedWeek, timesheetUtils } from '@/services/timesheetService'

interface UnsubmittedWeekAlertProps {
  week: UnsubmittedWeek
  onCreateTimesheet: (weekStart: string) => void
}

const UnsubmittedWeekAlert: React.FC<UnsubmittedWeekAlertProps> = ({
  week,
  onCreateTimesheet
}) => {
  return (
    <div className="card p-6 bg-gradient-to-r from-red-50 to-pink-50 border-red-200 unsubmitted-alert">
      <div className="flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
        <div className="flex-1 text-center md:text-left">
          <h2 className="text-lg font-semibold text-red-800 mb-2 flex items-center justify-center md:justify-start">
            <AlertTriangle className="w-5 h-5 mr-2" />
            🚨 緊急提醒！工時申報逾期
          </h2>
          <h3 className="text-md font-medium text-gray-900 mb-1">
            📅 {timesheetUtils.formatWeekRange(week.weekStart, week.weekEnd)} 週次工時尚未申報
          </h3>
          <p className="text-gray-600">
            📊 已記錄 {week.totalHours.toFixed(1)} 小時，共 {week.workingDays} 個工作日 • 
            <span className="text-red-600 font-medium ml-1">🔴 逾期 {week.overdueDays} 天</span>
          </p>
        </div>
        <div className="flex justify-center md:justify-start">
          <button
            onClick={() => onCreateTimesheet(week.weekStart)}
            className="px-8 py-3 w-full md:w-auto bg-red-600 hover:bg-red-700 text-white rounded-md transition-all duration-200 font-medium hover:shadow-md hover:transform hover:-translate-y-0.5"
          >
            ⚡ 立即申報
          </button>
        </div>
      </div>
    </div>
  )
}

export default UnsubmittedWeekAlert
